import { connect } from 'react-redux';
import { Actions as ProductionWorkflowAdditionalTasksActions } from 'pages/production-workflow/controllers/production-workflow-additional-tasks.controller';
import { ActivityAdditionalItemIcon } from 'icons/activity-additional-item';
import s from '../manage-failed-tasks-modal.module.scss';

type DispatchProps = {
  addTemporaryAdditionalTask: VoidFunction;
};
type Props = DispatchProps;

const EmptyStateNotFinishedAdditionalTasks = ({ addTemporaryAdditionalTask }: Props) => (
  <div className={s.empty_state_additional_task_newly_container}>
    <div className={s.empty_state_additional_task_newly}>
      <div className={s.empty_state_additional_task_text}>
        <div className={s.icon_container}>
          <ActivityAdditionalItemIcon height={32} width={32} className={s.icon} />
        </div>
        <p>
          No additional tasks.{' '}
          <span className={s.empty_state_additional_items} onClick={addTemporaryAdditionalTask}>
            Add additional task
          </span>
        </p>
      </div>
    </div>
  </div>
);

const mapDispatchToProps: DispatchProps = {
  addTemporaryAdditionalTask: ProductionWorkflowAdditionalTasksActions.addTemporaryAdditionalTask,
};
export default connect(null, mapDispatchToProps)(EmptyStateNotFinishedAdditionalTasks);
